module.exports = __webpack_public_path__ + "static/media/tpn-homepage-new.b714ad01.jpg";